import { gql } from '@apollo/client'

export default gql(`
    mutation deleteAssetImages($deletedId: [ID]! $assetId: ID! $project: String) {
        deleteAssetImages(
            input:  $deletedId,
            assetId: $assetId,
            project: $project
        )
    }`
)
